import { createBrowserHistory } from 'history';

import { getObjProp } from '../tools';
import getAppConfig, { initialConfig } from './get-app-config';

/**
 * Restore the original URI after authentication
 * or redirect to the default post-login route.
 */
const restoreOriginalUri = async (
  _: unknown,
  originalUri?: string
): Promise<void> => {
  const appConfig = getAppConfig();
  const { login, server } = appConfig;
  const { path } = server;
  const { redirectAfterLogin } = login;

  const redirect =
    originalUri && originalUri !== window.location.origin
      ? originalUri
      : `${path}${redirectAfterLogin}`;

  const history = createBrowserHistory();
  history.push(redirect);
  history.go(0);
};

// Runtime app config injected on window (if present)
const runtimeAppConfig =
  (window as { __APP_CONFIG__?: Partial<typeof initialConfig> }).__APP_CONFIG__ ||
  {};

// Merge configs exactly like JS
const config = { ...initialConfig, ...runtimeAppConfig };

/**
 * Retrieve a config value by key path
 */
const appConfiguration = (key = ''): unknown =>
  key === '' ? null : getObjProp(key, config);

export { appConfiguration, restoreOriginalUri };